var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewTabIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.375 16.375C1.89375 16.375 1.48177 16.2036 1.13906 15.8609C0.796354 15.5182 0.625 15.1062 0.625 14.625V2.375C0.625 1.89375 0.796354 1.48177 1.13906 1.13906C1.48177 0.796354 1.89375 0.625 2.375 0.625H8.5V2.375H2.375V14.625H14.625V8.5H16.375V14.625C16.375 15.1062 16.2036 15.5182 15.8609 15.8609C15.5182 16.2036 15.1062 16.375 14.625 16.375H2.375ZM6.4875 11.7375L5.2625 10.5125L13.4 2.375H10.25V0.625H16.375V6.75H14.625V3.6L6.4875 11.7375Z",
    fill: "#054254"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewTabIcon);
export default __webpack_public_path__ + "static/media/NewTabIcon.f5a1267d6cf8dccdc3828fe94b4e9480.svg";
export { ForwardRef as ReactComponent };